import { render, staticRenderFns } from "./LinkTextFile.vue?vue&type=template&id=44ec5840&"
import script from "./LinkTextFile.vue?vue&type=script&lang=js&"
export * from "./LinkTextFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44ec5840')) {
      api.createRecord('44ec5840', component.options)
    } else {
      api.reload('44ec5840', component.options)
    }
    module.hot.accept("./LinkTextFile.vue?vue&type=template&id=44ec5840&", function () {
      api.rerender('44ec5840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/LinkTextFile.vue"
export default component.exports